"use client";
import "./usp.scss";
import { Heading, TextAttr, IconAttr, RepeaterAttr } from "@/core/blocks/attributes";

export default function UspBlock() {
  return (
    <section className="block-usp">
      <div className="container">
        <Heading name="title" className="section-title" placeholder={{ nl: "Waarom voor ons kiezen", en: "Why choose us" }} />
        <RepeaterAttr name="items" as="div" className="usp-grid" addLabel={{ nl: "USP", en: "USP" }} itemDefaults={() => ({ icon: "star", text: {} })}>
          {() => (
            <div className="usp-item">
              <IconAttr name="icon" className="usp-icon" />
              <TextAttr name="text" rich as="p" className="usp-text" placeholder={{ nl: "Beschrijf deze USP…", en: "Describe this USP…" }} />
            </div>
          )}
        </RepeaterAttr>
      </div>
    </section>
  );
}

export const meta = { label: "USPs", icon: "stars" };

export function defaults(): Record<string, unknown> {
  return {
    title: { nl: "Waarom kiezen voor mij" },
    items: [
      { icon: "bolt", text: { nl: "Snel" } },
      { icon: "verified", text: { nl: "Betrouwbaar" } },
      { icon: "palette", text: { nl: "Creatief" } },
    ],
  };
}
